import React from "react";

import Icon, { IconName } from "../icons";
import s from "./ui.module.scss";

// ── Input ───────────────────────────────────────────────────────────────────────
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Optional leading icon (e.g. "search"). */
  leftIcon?: IconName;
  /** Red error border (pair with a FormField error message). */
  invalid?: boolean;
  wrapClassName?: string;
}

export const Input = ({ leftIcon, invalid, wrapClassName, className, ...rest }: InputProps) => (
  <div className={[s.field, wrapClassName].filter(Boolean).join(" ")}>
    {leftIcon && (
      <span className={s.fieldIcon}>
        <Icon name={leftIcon} size={15} />
      </span>
    )}
    <input
      className={[s.input, leftIcon && s.hasIcon, invalid && s.invalid, className].filter(Boolean).join(" ")}
      {...rest}
    />
  </div>
);

// ── Select ──────────────────────────────────────────────────────────────────────
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  wrapClassName?: string;
  children: React.ReactNode;
}

export const Select = ({ invalid, wrapClassName, className, children, ...rest }: SelectProps) => (
  <span className={[s.selectWrap, wrapClassName].filter(Boolean).join(" ")}>
    <select className={[s.select, invalid && s.invalid, className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </select>
    <span className={s.selectChevron}>
      <Icon name="chevron-down" size={16} />
    </span>
  </span>
);
